import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  font-weight: 600;\n  line-height: 1.5;\n  font-size: 16px;\n  letter-spacing: -0.16px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import styled from "styled-components";
//handout breakpoint는 다름.
export const HANDOUT_BREAK_POINT = {
    MOBILE: 768,
    TABLET: 1080,
    PC: 1200
};
export const Title = styled.h5.withConfig({
    componentId: "sc-4439b192-0"
})(_templateObject());
